export enum QuoteErrorTypeEnum {
  THIRD_PARTY_ERROR = "THIRD_PARTY_ERROR",
  AWB_NOT_AVAILABLE = "AWB_NOT_AVAILABLE",
  AWB_ALREADY_USED = "AWB_ALREADY_USED",
  AWB_NOT_PART_OF_STOCK = "AWB_NOT_PART_OF_STOCK",
}
